import VideoScreen from './VideoScreen.container';

export default VideoScreen;
